exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-amobile-layers-forbidden{cursor:no-drop}\n", ""]);

// exports
